export const visit = (vm, at) => {
at({ "zh-cn": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "\u62B1\u6B49\uFF0C\u6211\u4EEC\u65E0\u6CD5\u9A8C\u8BC1\u4F60\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002" } } } });
};